import React from 'react';
import SourceClearSpinner from '~/containers/SourceClearSpinner';
type LoaderWrapperProps = {
  isLoaderShowing?: boolean;
  className?: string;
  loaderClassName?: string;
  size?: string;
  loaderType?: string;
  customLoader?: object;
};
const LoaderWrapper: React.SFC<LoaderWrapperProps> = props => {
  const {
    isLoaderShowing,
    className,
    size = 'font--h4',
    loaderType = 'DEFAULT',
    customLoader = null,
    loaderClassName = '',
  } = props;
  const LOADER_TYPES = {
    DEFAULT: <SourceClearSpinner />,
    SPINNER: <i className={`fa fa-spin fa-spinner color--muted-dark ${size}`} />,
  };
  const loaderHtml = customLoader ? customLoader : LOADER_TYPES[loaderType];
  return (
    <div className={className}>
      {isLoaderShowing ? <div className={loaderClassName}>{loaderHtml}</div> : props.children}
    </div>
  );
};
export default LoaderWrapper;
